// src/pages/RegisterForm.js

import React, { useState } from 'react';
import RegisterStepOne from '../components/RegisterStepOne';
import RegisterStepTwo from '../components/RegisterStepTwo';
import { useAuth } from '../context/AuthContext';
import Navbar from '../components/Navbar';  // Adjust the path if necessary

const RegisterForm = () => {
    const [step, setStep] = useState(1);
    const [userEmail, setUserEmail] = useState('');
    const { isLoggedIn } = useAuth();  // Get login status to hide Navbar

    const handleNext = (email) => {
        setUserEmail(email);  // Save the email from Step 1
        setStep(2);  // Move to Step 2
    };

    return (
        <div>
            {step !== 1 && step !== 2 && !isLoggedIn && <Navbar />} 
            {step === 1 && <RegisterStepOne onNext={handleNext} />}
            {step === 2 && <RegisterStepTwo userEmail={userEmail} />}
        </div>
    );
};

export default RegisterForm;
